import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "distribution-options"
    }}>{`Distribution Options`}</h1>
    <p>{`Once you have a packaged plugin, you're ready to distribute it. Here are your options:`}</p>
    <ul>
      <li parentName="ul">{`Keep the plugin to yourself. This is OK, but you'll never become a YouTube star that way.`}</li>
      <li parentName="ul">{`Give the plugin to your family, friends, and workmates. You can email the `}<inlineCode parentName="li">{`.ccx`}</inlineCode>{` file or, more likely, put it on a cloud folder somewhere for them to download. All they need to do is double click the `}<inlineCode parentName="li">{`.ccx`}</inlineCode>{` file to install using the Creative Cloud application. It's that easy! Be aware that distributing this way will require them to click through the "do you trust this?" warning dialog boxes that appear after they double-click.`}</li>
      <li parentName="ul">{`You can submit it to the Creative Cloud Marketplace, where it can be discovered by millions of potential users. Both paid and free plugins are supported in the Marketplace; you choose which kind your plugin should be.`}</li>
    </ul>
    <p>{`If you've decided to submit your plugin to the Marketplace, read about the submissions process and review guidelines `}<a parentName="p" {...{
        "href": "../submission-checklist/"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      